import { HTMLAttributeAnchorTarget } from "react"

interface IProps {
  text: string | JSX.Element
  href?: string
  fontSize?: string | number
  target?: HTMLAttributeAnchorTarget
}

const CustomLink = ({text, href, fontSize, target}: IProps) => {

  return (
    <a
      href={href}
      style={{
        textDecoration: "none",
        color: "#00537e",
        fontSize: fontSize
      }}
      target={target}
    >
      {text}
    </a>
  )
}

export default CustomLink